// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
// import '@/permission'

// import { mockXHR } from '../mock'

import '@/assets/scss/element-ui-kaow/element-ui-kaow.scss'
import '@/assets/scss/kaow/kaow.scss'
import '@/assets/scss/component/base.scss'

import KwAlert from '@/components/custom/KwAlert'

import ElementUI from 'element-ui'
// if (process.env.NODE_ENV === 'development') {
//   mockXHR()
// }

Vue.config.productionTip = false

Vue.use(ElementUI, { size: 'medium' })
Vue.use(KwAlert)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App />',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js